/* KBN — Gift Newsletter Popup
 * --------------------------------------------------------------
 * Custom-Element <gift-newsletter-popup>. Liest die Konfiguration
 * aus data-* Attributen, regelt Apparition (Timer + Exit-Intent),
 * den Submit an den KBN-Bridge Worker, und den Form→Success
 * State-Wechsel.
 *
 * Storage-Keys (pro section-prefix):
 *   {prefix}:submitted     → "1" sobald erfolgreich submittet
 *   {prefix}:closed-until  → ISO-Date oder "forever"
 *
 * Submit-Endpoint:
 *   POST {worker}/newsletter-subscribe
 *   Body: { email, locale, language, country, list_id?,
 *           event_name?, customer_tag?, source: 'gift-newsletter-popup' }
 *
 * Im Theme-Editor (request.design_mode): immer sofort öffnen,
 * keine Persistenz, kein Timer.
 */
(function () {
  'use strict';

  if (window.__KBN_GIFT_NEWSLETTER_INIT__) return;
  window.__KBN_GIFT_NEWSLETTER_INIT__ = true;

  var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function nowMs() { return Date.now(); }

  function safeStorageGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }
  function safeStorageSet(key, value) {
    try { localStorage.setItem(key, value); } catch (e) {}
  }
  function safeSessionGet(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function safeSessionSet(key, value) {
    try { sessionStorage.setItem(key, value); } catch (e) {}
  }

  // Mobile-Check: kein Exit-Intent auf Touch-Devices (Maus-leave
  // existiert dort nicht meaningful).
  function isLikelyMobile() {
    if (typeof window.matchMedia === 'function') {
      return window.matchMedia('(pointer: coarse)').matches;
    }
    return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent || '');
  }

  function parseBool(val) {
    if (val == null) return false;
    var s = String(val).toLowerCase();
    return s === 'true' || s === '1' || s === 'yes';
  }

  function GiftNewsletterPopup() {
    return Reflect.construct(HTMLElement, [], GiftNewsletterPopup);
  }
  GiftNewsletterPopup.prototype = Object.create(HTMLElement.prototype);
  GiftNewsletterPopup.prototype.constructor = GiftNewsletterPopup;
  Object.setPrototypeOf(GiftNewsletterPopup, HTMLElement);

  GiftNewsletterPopup.prototype.connectedCallback = function () {
    if (this._mounted) return;
    this._mounted = true;

    var ds = this.dataset;
    this.cfg = {
      sectionId:       ds.sectionId || 'gift',
      engagementMs:    parseInt(ds.engagementMs || '150000', 10),
      enableExitIntent: parseBool(ds.enableExitIntent),
      rememberCloseFor: ds.rememberCloseFor || '30d',
      storagePrefix:   ds.storagePrefix || 'kbn-gift-newsletter',
      workerUrl:       (ds.workerUrl || '').replace(/\/+$/, ''),
      listId:          ds.listId || '',
      eventName:       ds.eventName || '',
      customerTag:     ds.customerTag || '',
      locale:          ds.locale || '',
      language:        ds.language || '',
      country:         ds.country || '',
      customerId:      ds.customerId || '',
      editorMode:      ds.editorMode === '1',
      // Editor-Vorschau-State: kommt aus dem section.settings.editor_preview_state
      // setting (Theme-Editor-only). Liquid setzt das attribute nur wenn
      // editorMode=1. Auf der Live-Seite ist es 'form' (Default).
      editorState:     ds.editorState || 'form',
      testMode:        false
    };

    // Test-Modus via URL-Param ODER Hash. Hash-Fallback (#kbn_popup=…)
    // ist wichtig wenn Shopify-Locale-Redirects (z.B. /en) Query-Strings
    // strippen — URL-Fragmente überleben Redirects.
    //
    //   ?kbn_popup_test=1        → Form-State (Default)
    //   ?kbn_popup_test=success  → springt direkt in Success-State
    //   ?kbn_popup=open          → Alias für test=1
    //   ?kbn_popup=success       → Alias für test=success
    //   ?kbn_popup=tear          → Form-State + Submit-Click triggert
    //                              die Tear-Animation OHNE Worker-Call
    //                              (keine Email nötig, refreshen =
    //                              Animation beliebig wiederholbar)
    //   ?kbn_popup=reset         → Löscht alle Storage-Flags
    //
    // Funktionieren alle auch als Hash: #kbn_popup=tear etc.
    //
    // ALTERNATIV: Console-Trigger (siehe window.kbnTear unten am
    // Skript-Ende) — funktioniert ohne URL-Param, auch wenn das
    // Popup schon geöffnet ist.
    this.cfg.testState = 'form';
    this.cfg.testFakeSubmit = false;
    try {
      var qs = new URLSearchParams(window.location.search || '');
      var hashStr = (window.location.hash || '').replace(/^#/, '');
      var hp = new URLSearchParams(hashStr);
      var testVal =
        qs.get('kbn_popup_test') || qs.get('kbn_popup') ||
        hp.get('kbn_popup_test') || hp.get('kbn_popup');
      if (testVal === '1' || testVal === 'open' || testVal === 'success' || testVal === 'tear') {
        this.cfg.testMode = true;
        if (testVal === 'success') this.cfg.testState = 'success';
        if (testVal === 'tear')    this.cfg.testFakeSubmit = true;
      }
      var resetVal = qs.get('kbn_popup') || hp.get('kbn_popup');
      if (resetVal === 'reset') {
        this._clearAllStorage();
        console.log('[kbn-gift-newsletter] Storage-Flags gelöscht. Reload die Page (ohne den URL-Param) um den Normal-Flow zu testen.');
      }
    } catch (e) {}

    this.els = {
      backdrop:    this.querySelector('[data-popup-backdrop]'),
      closeBtn:    this.querySelector('[data-popup-close]'),
      form:        this.querySelector('[data-popup-form]'),
      emailInput:  this.querySelector('[data-popup-email]'),
      submitBtn:   this.querySelector('[data-popup-submit]'),
      errorEl:     this.querySelector('[data-popup-error]'),
      formPanel:   this.querySelector('[data-popup-state="form"]'),
      successPanel:this.querySelector('[data-popup-state="success"]'),
      successBtn:  this.querySelector('[data-popup-success-btn]')
    };

    this._bindEvents();

    if (this.cfg.editorMode || this.cfg.testMode) {
      // Theme-Editor ODER Test-Mode: sofort öffnen, alle Gates ignoriert.
      this._open({ trigger: this.cfg.testMode ? 'test-mode' : 'editor' });
      // Direkt in Success-Panel wechseln wenn:
      //   - ?kbn_popup=success (Live-URL Dev-Shortcut)
      //   - Editor mit editor_preview_state='success'
      var showSuccess =
        (this.cfg.testMode && this.cfg.testState === 'success') ||
        (this.cfg.editorMode && this.cfg.editorState === 'success');
      if (showSuccess) {
        this._switchToSuccessState();
      }
      // Editor mit editor_preview_state='tear-loop': Tear-Animation
      // läuft im Loop (Form → Tear → Success → kurzer Pause → Reset
      // → Form → …). So tunest du die Animation im Editor visuell
      // ohne URL-Param oder Console-Calls.
      if (this.cfg.editorMode && this.cfg.editorState === 'tear-loop') {
        this._startEditorTearLoop();
      }
      return;
    }

    if (!this._shouldShow()) {
      this._cleanup();
      return;
    }

    this._registerTriggers();
  };

  GiftNewsletterPopup.prototype.disconnectedCallback = function () {
    this._cleanup();
  };

  // -----------------------------------------------------------------
  // Trigger / Apparition Logic
  // -----------------------------------------------------------------
  GiftNewsletterPopup.prototype._registerTriggers = function () {
    var self = this;

    // 1) Engagement-Timer (Cross-Page kumulativ)
    if (window.KBNEngagement && this.cfg.engagementMs > 0) {
      var key = 'gift-popup:' + this.cfg.sectionId;
      this._engagementKey = key;
      this._engagementHandler = function (e) {
        if (e.detail && e.detail.key === key) {
          self._open({ trigger: 'engagement' });
        }
      };
      document.addEventListener('kbn:engagement-reached', this._engagementHandler);
      window.KBNEngagement.on(this.cfg.engagementMs, key);
    }

    // 2) Exit-Intent (Desktop only)
    if (this.cfg.enableExitIntent && !isLikelyMobile()) {
      this._exitIntentHandler = function (e) {
        // Maus verlässt nach oben den Viewport — relatedTarget = null
        // = nach außerhalb des window, clientY <=0 = nach oben.
        if (e.clientY <= 0 && !e.relatedTarget) {
          self._open({ trigger: 'exit-intent' });
        }
      };
      // Erst nach kurzer Karenzzeit aktivieren, sonst feuert es
      // sofort wenn der User die Maus oben hat beim Page-Load.
      this._exitIntentTimeout = setTimeout(function () {
        document.documentElement.addEventListener('mouseout', self._exitIntentHandler);
      }, 4000);
    }
  };

  // -----------------------------------------------------------------
  // Event-Binding (Close-Button, Backdrop, ESC, Submit)
  // -----------------------------------------------------------------
  GiftNewsletterPopup.prototype._bindEvents = function () {
    var self = this;

    if (this.els.closeBtn) {
      this.els.closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        self._close({ reason: 'close-button' });
      });
    }

    if (this.els.backdrop) {
      this.els.backdrop.addEventListener('click', function () {
        self._close({ reason: 'backdrop' });
      });
    }

    this._keydownHandler = function (e) {
      if (e.key === 'Escape' && self.hasAttribute('data-open')) {
        e.preventDefault();
        self._close({ reason: 'escape' });
      }
    };
    document.addEventListener('keydown', this._keydownHandler);

    if (this.els.form) {
      this.els.form.addEventListener('submit', function (e) {
        e.preventDefault();
        self._submit();
      });
    }
  };

  // -----------------------------------------------------------------
  // Should-Show Logik (Storage-State Checks)
  // -----------------------------------------------------------------
  GiftNewsletterPopup.prototype._shouldShow = function () {
    var prefix = this.cfg.storagePrefix;

    // 0) Geschenk schon über den EG-Magic-Link aktiv? Dann hat der Kunde sich
    //    bereits angemeldet und das Geschenk freigeschaltet → Popup NICHT
    //    zeigen (auch wenn ':submitted' auf DIESEM Browser fehlt, z.B. weil der
    //    Magic-Link auf einem anderen Gerät geöffnet wird).
    if (this._giftAlreadyActive()) return false;

    // 1) Hat der User schon submitted?
    if (safeStorageGet(prefix + ':submitted') === '1') return false;

    // 2) Wurde das Popup geschlossen, und falls ja — Sperre aktiv?
    var closedUntilLS = safeStorageGet(prefix + ':closed-until');
    var closedUntilSS = safeSessionGet(prefix + ':closed-session');

    if (closedUntilSS === '1' && this.cfg.rememberCloseFor === 'session') {
      return false;
    }

    if (closedUntilLS === 'forever') return false;

    if (closedUntilLS) {
      var until = parseInt(closedUntilLS, 10);
      if (!isNaN(until) && until > nowMs()) return false;
    }

    return true;
  };

  // Geschenk bereits aktiv? (Magic-Link genutzt) — dann das Newsletter-Popup
  // unterdrücken. Drei Ebenen, robust gegen Lade-Reihenfolge:
  //   a) ?aca=… direkt in URL/Hash (greift sofort beim Landing)
  //   b) window.KBNGift.isActive() (liest EGs echten Zustand; falls schon geladen)
  //   c) Fallback: das von kbn-gift-claim.js beim Landing gesetzte Flag
  //      (kbn-gift:active + :active-until) — überlebt Folge-Seitenaufrufe im
  //      Gültigkeits-Fenster, auch wenn der ?aca=-Param längst weg ist.
  GiftNewsletterPopup.prototype._giftAlreadyActive = function () {
    try {
      var qs = new URLSearchParams(window.location.search || '');
      var hp = new URLSearchParams((window.location.hash || '').replace(/^#/, ''));
      if (qs.get('aca') || hp.get('aca')) return true;
    } catch (e) {}
    try {
      if (window.KBNGift && typeof window.KBNGift.isActive === 'function' && window.KBNGift.isActive()) {
        return true;
      }
    } catch (e) {}
    try {
      if (safeStorageGet('kbn-gift:active') === '1') {
        var until = parseInt(safeStorageGet('kbn-gift:active-until') || '0', 10);
        if (until && until >= nowMs()) return true;
      }
    } catch (e) {}
    return false;
  };

  // -----------------------------------------------------------------
  // Open / Close
  // -----------------------------------------------------------------
  GiftNewsletterPopup.prototype._open = function (opts) {
    if (this.hasAttribute('data-open')) return;

    // Sicherheitsnetz gegen Lade-Reihenfolge: falls KBNGift erst NACH
    // _shouldShow geladen wurde und das Geschenk aktiv ist, hier nochmal
    // abfangen (Trigger feuert erst nach Timer/Exit-Intent). Editor/Test
    // bleiben ausgenommen, damit man das Popup dort weiter testen kann.
    if (!this.cfg.editorMode && !this.cfg.testMode && this._giftAlreadyActive()) {
      this._cleanup();
      return;
    }
    this.removeAttribute('hidden');
    this.setAttribute('data-open', '1');
    document.body.classList.add('kbn-gift-popup-open');

    // Focus auf Email-Input (a11y) — kurz delayen damit Animation
    // nicht durch Focus-Outline gestört wird.
    var self = this;
    setTimeout(function () {
      if (self.els.emailInput && !self._isSuccessState()) {
        self.els.emailInput.focus();
      }
    }, 280);

    // Engagement-Threshold abmelden (sonst feuert es nach Close
    // immer wieder beim nächsten Page-Load)
    if (window.KBNEngagement && this._engagementKey) {
      window.KBNEngagement.off(this._engagementKey);
    }
    if (this._exitIntentHandler) {
      document.documentElement.removeEventListener('mouseout', this._exitIntentHandler);
    }
    clearTimeout(this._exitIntentTimeout);

    this._dispatchEvent('kbn:gift-popup:opened', { trigger: (opts || {}).trigger });
  };

  GiftNewsletterPopup.prototype._close = function (opts) {
    if (!this.hasAttribute('data-open')) return;
    this.removeAttribute('data-open');
    this.setAttribute('hidden', '');
    document.body.classList.remove('kbn-gift-popup-open');

    // Mid-Animation close: User drückt ESC oder klickt Backdrop während
    // die Tear-Animation läuft. Ohne diesen Branch würde der pending
    // setTimeout später feuern, is-success-state setzen und die min-height
    // pinned lassen → next open zeigt korrupten State.
    if (this._isTearing && !this.classList.contains('is-success-state')) {
      this._resetToFormState();
    }

    // Nur persistieren wenn nicht im Editor oder Test-Mode geschlossen
    if (!this.cfg.editorMode && !this.cfg.testMode) {
      this._persistCloseDecision();
    }

    this._dispatchEvent('kbn:gift-popup:closed', { reason: (opts || {}).reason });
  };

  GiftNewsletterPopup.prototype._persistCloseDecision = function () {
    var prefix = this.cfg.storagePrefix;
    var mode = this.cfg.rememberCloseFor;

    if (mode === 'forever') {
      safeStorageSet(prefix + ':closed-until', 'forever');
    } else if (mode === 'session') {
      safeSessionSet(prefix + ':closed-session', '1');
    } else if (mode === '7d') {
      safeStorageSet(prefix + ':closed-until', String(nowMs() + 7 * 24 * 60 * 60 * 1000));
    } else if (mode === '30d') {
      safeStorageSet(prefix + ':closed-until', String(nowMs() + 30 * 24 * 60 * 60 * 1000));
    }
  };

  // -----------------------------------------------------------------
  // Submit (POST → Worker)
  // -----------------------------------------------------------------
  GiftNewsletterPopup.prototype._submit = function () {
    var self = this;
    var emailRaw = (this.els.emailInput.value || '').trim();
    var email = emailRaw.toLowerCase();

    this._clearError();

    // ?kbn_popup=tear → Fake-Submit: kein Worker, keine Validation,
    // einfach direkt in die Tear-Animation. Refreshen = Animation
    // beliebig oft wiederholbar ohne echte Email zu submitten.
    if (this.cfg.testMode && this.cfg.testFakeSubmit) {
      this._onSubmitSuccess(email || 'test@example.com', { fake: true });
      return;
    }

    if (!email) {
      this._showError('Bitte gib deine E-Mail-Adresse ein.');
      return;
    }
    if (!EMAIL_REGEX.test(email)) {
      this._showError('Diese E-Mail-Adresse sieht ungültig aus.');
      return;
    }
    if (!this.cfg.workerUrl) {
      this._showError('Newsletter-Anmeldung nicht konfiguriert. Bitte später erneut versuchen.');
      return;
    }

    this._setSubmitting(true);

    var payload = {
      email: email,
      locale: this.cfg.locale,
      language: this.cfg.language,
      country: this.cfg.country,
      source: 'gift-newsletter-popup',
      section_id: this.cfg.sectionId
    };
    if (this.cfg.listId)      payload.list_id = this.cfg.listId;
    if (this.cfg.eventName)   payload.event_name = this.cfg.eventName;
    if (this.cfg.customerTag) payload.customer_tag = this.cfg.customerTag;

    var endpoint = this.cfg.workerUrl + '/newsletter-subscribe';

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'omit',
      keepalive: true
    })
    .then(function (res) {
      // 2xx + 409 (already subscribed) als Erfolg behandeln — der
      // User soll keinen Fehler sehen wenn er sich nochmal anmeldet.
      if (res.ok || res.status === 409) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          return { ok: true, data: data };
        });
      }
      return res.json().catch(function () { return {}; }).then(function (data) {
        return { ok: false, status: res.status, data: data };
      });
    })
    .then(function (result) {
      self._setSubmitting(false);
      if (result.ok) {
        self._onSubmitSuccess(email, result.data);
      } else {
        var msg = (result.data && result.data.error)
          ? self._humanError(result.data.error)
          : 'Etwas ist schief gelaufen. Bitte versuche es in einem Moment erneut.';
        self._showError(msg);
      }
    })
    .catch(function (err) {
      self._setSubmitting(false);
      self._showError('Verbindung fehlgeschlagen. Prüfe deine Internetverbindung und versuche es erneut.');
      // eslint-disable-next-line no-console
      console.warn('[kbn-gift-newsletter] submit error', err);
    });
  };

  GiftNewsletterPopup.prototype._humanError = function (code) {
    var map = {
      'invalid_email': 'Diese E-Mail-Adresse sieht ungültig aus.',
      'rate_limited':  'Bitte warte einen Moment und versuche es erneut.',
      'invalid_payload': 'Eingabe ungültig. Bitte prüfe deine E-Mail-Adresse.'
    };
    return map[code] || 'Etwas ist schief gelaufen. Bitte versuche es erneut.';
  };

  // Setzt den "Zur Mailbox"-Button so, dass er den Posteingang des Kunden
  // öffnet (dort liegt die Bestätigungs-Mail) — nicht ein leeres Compose-
  // Fenster wie das alte 'mailto:'. Strategie:
  //   1. Bekannter Provider → direkt dessen Webmail-Inbox (Desktop + Mobile-
  //      Browser, am zuverlässigsten "ihre Mailbox").
  //   2. Unbekannte Domain + iOS → message:// öffnet die Standard-Mail-App.
  //   3. Unbekannte Domain + Android → Gmail-App-Schema (dort meist Default).
  // App-Schemes öffnen NICHT in neuem Tab (sonst bleibt ein leerer Tab zurück).
  GiftNewsletterPopup.prototype._setMailboxLink = function (email) {
    var btn = this.els.successBtn;
    if (!btn) return;

    // Einmal-Guard + Merchant-URL respektieren: nur den Default 'mailto:'
    // (= leeres success_button_url-Setting im Liquid) überschreiben.
    if (this._mailboxApplied) return;
    var existing = (btn.getAttribute('href') || '').trim();
    if (existing && existing !== 'mailto:') return;

    var domain = (String(email || '').split('@')[1] || '').toLowerCase();
    var WEBMAIL = {
      'gmail.com': 'https://mail.google.com/mail/u/0/#inbox',
      'googlemail.com': 'https://mail.google.com/mail/u/0/#inbox',
      'web.de': 'https://web.de/email/',
      'gmx.de': 'https://www.gmx.net/', 'gmx.net': 'https://www.gmx.net/', 'gmx.at': 'https://www.gmx.at/', 'gmx.ch': 'https://www.gmx.ch/',
      't-online.de': 'https://email.t-online.de/',
      'outlook.com': 'https://outlook.live.com/mail/', 'outlook.de': 'https://outlook.live.com/mail/', 'outlook.at': 'https://outlook.live.com/mail/',
      'hotmail.com': 'https://outlook.live.com/mail/', 'hotmail.de': 'https://outlook.live.com/mail/',
      'live.com': 'https://outlook.live.com/mail/', 'live.de': 'https://outlook.live.com/mail/', 'live.at': 'https://outlook.live.com/mail/',
      'msn.com': 'https://outlook.live.com/mail/',
      'yahoo.com': 'https://mail.yahoo.com/', 'yahoo.de': 'https://mail.yahoo.com/',
      'icloud.com': 'https://www.icloud.com/mail', 'me.com': 'https://www.icloud.com/mail', 'mac.com': 'https://www.icloud.com/mail',
      'aol.com': 'https://mail.aol.com/', 'aol.de': 'https://mail.aol.com/',
      'proton.me': 'https://mail.proton.me/', 'protonmail.com': 'https://mail.proton.me/',
      'freenet.de': 'https://email.freenet.de/'
    };

    var ua = navigator.userAgent || '';
    var isIOS = /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var isAndroid = /Android/.test(ua);

    var href = WEBMAIL[domain] || null;
    if (!href) {
      if (isIOS) href = 'message://';
      else if (isAndroid) href = 'googlegmail://';
    }
    if (!href) return; // Desktop + unbekannte Domain → Default (mailto:) lassen

    btn.setAttribute('href', href);
    if (/^(message|googlegmail):/.test(href)) {
      btn.removeAttribute('target'); // App-Scheme: kein neuer Tab
    } else {
      btn.setAttribute('target', '_blank');
      btn.setAttribute('rel', 'noopener');
    }
    this._mailboxApplied = true;
  };

  GiftNewsletterPopup.prototype._onSubmitSuccess = function (email, data) {
    // "Zur Mailbox"-Button auf den Posteingang des Kunden routen.
    this._setMailboxLink(email);

    // Im Test-Mode kein submitted-Flag setzen, damit du beliebig oft
    // submitten kannst ohne localStorage zu clearen.
    if (!this.cfg.testMode) {
      var prefix = this.cfg.storagePrefix;
      safeStorageSet(prefix + ':submitted', '1');
      safeStorageSet(prefix + ':submitted-at', String(nowMs()));
      safeStorageSet(prefix + ':submitted-email', email);
    }

    // Echter Submit → Tear-Animation Form → Success.
    // Editor und Test-Mode (?kbn_popup=success) callen direkt
    // _switchToSuccessState aus connectedCallback (instant Preview,
    // keine Animation gewünscht beim UI-Tuning).
    this._animateToSuccessState();
    this._dispatchEvent('kbn:gift-popup:submitted', { email: email, data: data });
  };

  // Instant Panel-Wechsel — wird vom Editor und Test-Mode genutzt
  // (sofortige Preview des Success-Screens ohne Animation).
  GiftNewsletterPopup.prototype._switchToSuccessState = function () {
    if (this.els.formPanel) this.els.formPanel.setAttribute('hidden', '');
    if (this.els.successPanel) this.els.successPanel.removeAttribute('hidden');
    this.classList.add('is-success-state');
  };

  // Tear-Animation Form → Success. Optionales Feature — zum Entfernen
  // einfach diese ganze Funktion + _resetToFormState + _startEditorTearLoop
  // + window.kbnTear (am Ende der Datei) löschen, im _onSubmitSuccess oben
  // den Aufruf zurück auf _switchToSuccessState ändern (+ CSS-Block
  // "TEAR ANIMATION" in der Liquid-Sektion).
  GiftNewsletterPopup.prototype._animateToSuccessState = function () {
    var self = this;
    var dialog = this.querySelector('.kbn-gift-popup__dialog');

    // Reduced-motion User oder kein Dialog gefunden → instant switch.
    var prefersReducedMotion = (window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (!dialog || prefersReducedMotion) {
      this._switchToSuccessState();
      return;
    }

    // 1. Dialog-Höhe einfrieren als min-height. Verhindert dass der
    //    Dialog beim Form-display:none (am Ende der Animation) auf
    //    die Success-Höhe schrumpft und der Close-X-Button springt.
    var lockedHeight = dialog.offsetHeight;
    dialog.style.minHeight = lockedHeight + 'px';

    // 2. Success-Panel sichtbar machen (CSS hält Kinder bei opacity:0
    //    bis ihr stagger delay sie ins Bild rotiert).
    if (this.els.successPanel) this.els.successPanel.removeAttribute('hidden');

    // Re-entry guard: wenn Animation schon läuft, ignoriere zweiten Aufruf.
    // Verhindert race wenn z.B. kbnTear() doppelt geklickt wird oder
    // _onSubmitSuccess parallel zum manuellen Trigger feuert.
    if (this._isTearing) return;
    this._isTearing = true;

    // 3. requestAnimationFrame: garantiert dass der Browser min-height
    //    committed hat BEVOR die Keyframes starten (sonst race).
    requestAnimationFrame(function () {
      self.classList.add('is-tearing');

      // 4. Nach Animation-Ende den finalen State setzen.
      //    Cross-Fade dauert 500ms (Success-Fade endet bei 500ms)
      //    + 40ms Sicherheitspuffer = 540ms.
      //    Timer-Reference in self._tearTimer damit _close() ihn cancellen
      //    kann (User schließt mid-animation).
      self._tearTimer = setTimeout(function () {
        if (self.els.formPanel) self.els.formPanel.setAttribute('hidden', '');
        self.classList.remove('is-tearing');
        self.classList.add('is-success-state');
        self._isTearing = false;
        self._tearTimer = null;
        // min-height bleibt absichtlich gepinnt — Dialog behält
        // die Form-Höhe damit der Close-X nicht plötzlich
        // hochwandert wenn Success-Content kürzer ist.
      }, 540);
    });
  };

  // Reset auf Form-State — wird vom Editor-Loop, window.kbnTear, UND
  // _close (mid-tear close) genutzt um saubere Wiederholbarkeit zu
  // garantieren. _clearError + _setSubmitting cleanup damit nach
  // failed real-submits der Form nicht im disabled/spinner-State stehen
  // bleibt wenn man via kbnTear() neu öffnet.
  GiftNewsletterPopup.prototype._resetToFormState = function () {
    this.classList.remove('is-tearing');
    this.classList.remove('is-success-state');
    this._isTearing = false;
    if (this._tearTimer) {
      clearTimeout(this._tearTimer);
      this._tearTimer = null;
    }
    if (this.els.formPanel)    this.els.formPanel.removeAttribute('hidden');
    if (this.els.successPanel) this.els.successPanel.setAttribute('hidden', '');
    var dialog = this.querySelector('.kbn-gift-popup__dialog');
    if (dialog) dialog.style.minHeight = '';
    this._clearError();
    this._setSubmitting(false);
  };

  // Editor-Loop: Form → Tear → Success → Pause → Reset → Form → …
  // Wird vom editor_preview_state='tear-loop' Section-Setting gestartet.
  // So tunest du die Animation im Theme-Editor visuell ohne URL-Param.
  // _editorLoopTimer tracking damit _cleanup() den Loop kippen kann
  // wenn die Section unmounted (jeder Editor-Save re-renderiert die
  // Section → sonst chained setTimeouts gegen detached DOM für immer).
  GiftNewsletterPopup.prototype._startEditorTearLoop = function () {
    var self = this;
    this._editorTearLoopActive = true;
    var cycle = function () {
      if (!self._editorTearLoopActive) return;
      self._resetToFormState();
      self._editorLoopTimer = setTimeout(function () {
        if (!self._editorTearLoopActive) return;
        self._animateToSuccessState();
        // Animation (540ms) + Success-Verweildauer (1800ms) = 2340ms
        self._editorLoopTimer = setTimeout(cycle, 2340);
      }, 1200); // Form-Verweildauer bevor's losgeht
    };
    cycle();
  };

  // Löscht alle Storage-Flags die das Popup setzt. Nützlich für Reset
  // via ?kbn_popup=reset URL-Param ODER manuell aus der Console:
  //   document.querySelector('gift-newsletter-popup')._clearAllStorage()
  GiftNewsletterPopup.prototype._clearAllStorage = function () {
    var prefix = this.cfg.storagePrefix;
    var keys = [
      prefix + ':submitted',
      prefix + ':submitted-at',
      prefix + ':submitted-email',
      prefix + ':closed-until'
    ];
    keys.forEach(function (k) {
      try { localStorage.removeItem(k); } catch (e) {}
    });
    try { sessionStorage.removeItem(prefix + ':closed-session'); } catch (e) {}
  };

  GiftNewsletterPopup.prototype._isSuccessState = function () {
    return this.els.successPanel && !this.els.successPanel.hasAttribute('hidden');
  };

  GiftNewsletterPopup.prototype._setSubmitting = function (busy) {
    if (this.els.submitBtn) {
      this.els.submitBtn.disabled = busy;
      var label = this.els.submitBtn.querySelector('.kbn-gift-popup__submit-label');
      if (label) {
        if (busy) {
          if (!this._origSubmitLabel) this._origSubmitLabel = label.textContent;
          label.textContent = '…';
        } else if (this._origSubmitLabel) {
          label.textContent = this._origSubmitLabel;
        }
      }
    }
    if (this.els.emailInput) {
      this.els.emailInput.disabled = busy;
    }
  };

  GiftNewsletterPopup.prototype._showError = function (msg) {
    if (!this.els.errorEl) return;
    this.els.errorEl.textContent = msg;
    this.els.errorEl.removeAttribute('hidden');
  };
  GiftNewsletterPopup.prototype._clearError = function () {
    if (!this.els.errorEl) return;
    this.els.errorEl.textContent = '';
    this.els.errorEl.setAttribute('hidden', '');
  };

  GiftNewsletterPopup.prototype._dispatchEvent = function (name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
  };

  GiftNewsletterPopup.prototype._cleanup = function () {
    if (this._engagementHandler) {
      document.removeEventListener('kbn:engagement-reached', this._engagementHandler);
    }
    if (window.KBNEngagement && this._engagementKey) {
      window.KBNEngagement.off(this._engagementKey);
    }
    if (this._exitIntentHandler) {
      document.documentElement.removeEventListener('mouseout', this._exitIntentHandler);
    }
    if (this._keydownHandler) {
      document.removeEventListener('keydown', this._keydownHandler);
    }
    clearTimeout(this._exitIntentTimeout);

    // Editor-Loop killen (sonst feuern chained setTimeouts gegen detached
    // DOM für immer — Shopify Editor re-rendert die Section bei jedem
    // Setting-Change → disconnectedCallback feuert → ohne dieses Cleanup
    // sammeln sich Timer-Leaks bis zum Tab-Refresh).
    this._editorTearLoopActive = false;
    if (this._editorLoopTimer) {
      clearTimeout(this._editorLoopTimer);
      this._editorLoopTimer = null;
    }
    if (this._tearTimer) {
      clearTimeout(this._tearTimer);
      this._tearTimer = null;
    }
  };

  if (!window.customElements.get('gift-newsletter-popup')) {
    window.customElements.define('gift-newsletter-popup', GiftNewsletterPopup);
  }

  // ============================================================
  // Footer-Re-Entry-Point ([data-gift-footer] + [data-gift-popup-open])
  // ------------------------------------------------------------
  // Dieses Script lädt NUR, wenn das Popup gerendert wurde (alle Server-Gates
  // bestanden) → der Footer-Banner erbt automatisch dieselben Ausschlüsse.
  // Hier nur noch: ausblenden, wenn das Geschenk schon eingelöst ist
  // (submitted/aktiv), und den Button mit popup._open() verdrahten.
  // ============================================================
  function getGiftPopup() { return document.querySelector('gift-newsletter-popup'); }

  function giftAlreadyClaimed(popup) {
    try {
      var prefix = (popup && popup.cfg && popup.cfg.storagePrefix) || 'kbn-gift-newsletter';
      if (safeStorageGet(prefix + ':submitted') === '1') return true;
    } catch (e) {}
    if (popup && typeof popup._giftAlreadyActive === 'function' && popup._giftAlreadyActive()) {
      return true;
    }
    return false;
  }

  function syncGiftFooter() {
    var footers = document.querySelectorAll('[data-gift-footer]');
    if (!footers.length) return;
    var inEditor = !!(window.Shopify && window.Shopify.designMode);
    var popup = getGiftPopup();
    // Sichtbar, wenn das Popup existiert UND noch nicht eingelöst (Editor: immer).
    var show = inEditor || (!!popup && !giftAlreadyClaimed(popup));
    for (var i = 0; i < footers.length; i++) {
      if (show) footers[i].removeAttribute('hidden');
      else footers[i].setAttribute('hidden', '');
    }
  }

  // Re-Open via Footer-Button — delegiert, funktioniert auch wenn das Popup
  // zuvor via closed-until dormant gemacht wurde (Element + _open existieren).
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('[data-gift-popup-open]') : null;
    if (!trigger) return;
    e.preventDefault();
    var popup = getGiftPopup();
    if (!popup || typeof popup._open !== 'function') return;
    if (popup.hasAttribute('data-open')) return;
    if (typeof popup._resetToFormState === 'function') popup._resetToFormState();
    popup._open({ trigger: 'footer' });
  });

  document.addEventListener('DOMContentLoaded', syncGiftFooter);
  window.addEventListener('pageshow', syncGiftFooter);
  document.addEventListener('kbn:gift-popup:submitted', syncGiftFooter);
  document.addEventListener('kbn:gift-popup:closed', syncGiftFooter);

  // ============================================================
  // window.kbnTear() — DEV-Console-Trigger für die Tear-Animation.
  // Bewusst global + stable name damit du im Cache-Hell-Fall (Shopify-
  // CDN serviert alte JS, URL-Param greift nicht) die Animation
  // trotzdem manuell triggern kannst:
  //
  //   kbnTear()    → öffnet Popup wenn nötig, springt zurück auf
  //                  Form-State (falls schon im Success), feuert Tear
  //
  // Zum Entfernen: diesen ganzen Block löschen.
  // ============================================================
  window.kbnTear = function () {
    var popup = document.querySelector('gift-newsletter-popup');
    if (!popup) {
      console.warn('[kbn] <gift-newsletter-popup> Element nicht im DOM. Popup ist evtl. durch market_mode / page_type / enabled-Setting weggegated.');
      return;
    }
    if (popup._isTearing) {
      console.warn('[kbn] Tear-Animation läuft bereits — Aufruf ignoriert. Warte bis sie durch ist oder rufe popup._resetToFormState() auf.');
      return;
    }
    if (typeof popup._resetToFormState === 'function') {
      popup._resetToFormState();
    }
    if (!popup.hasAttribute('data-open') && typeof popup._open === 'function') {
      if (popup.cfg) popup.cfg.testMode = true;
      popup._open({ trigger: 'manual-tear' });
    }
    setTimeout(function () {
      if (typeof popup._animateToSuccessState === 'function') {
        popup._animateToSuccessState();
      }
    }, 120);
  };
})();
